import React from "react";
import { IonGrid, IonRow, IonCol } from "@ionic/react";
import { Constants } from "../Constants";

const GridList: React.FC<{
  data: any[] | null | undefined;
  renderItem: Function;
  numCols: number;
}> = ({ data, renderItem, numCols }) => {
  const getRenderItems = () => {
    const renderItems: any[] = [];
    data?.forEach((tier) => {
      renderItems.push(renderItem(tier));
    });
    return renderItems;
  };

  const addCols = (renderItems: any[]) => {
    const cols: any[] = [];
    for (let col = 0; col < numCols; col++) {
      renderItems.length > 0
        ? cols.push(
            <IonCol size={`${Constants.LCM / numCols}`} key={col}>
              {renderItems.shift()}
            </IonCol>
          )
        : cols.push(<IonCol key={col}></IonCol>);
    }
    return cols;
  };

  const addRows = () => {
    const rows: any[] = [];
    const renderItems = getRenderItems();
    const numRows = Math.ceil(renderItems.length / numCols);
    for (let row = 0; row < numRows; row++) {
      rows.push(<IonRow key={row}>{addCols(renderItems)}</IonRow>);
    }
    return rows;
  };

  return <IonGrid>{addRows()}</IonGrid>;
};

export default GridList;
